import { useCallback, useEffect, useState } from 'react'

// Quick-view gallery state for the results grid, ported from ListingPage's List.jsx. ModelCard
// renders the panel itself - as a full-width row item after the last card on the selected model's
// line - so this hook only owns which model is open.
const useResultsGallery = (resultIdsSignature) => {
  const [showGallery, setShowGallery] = useState(null)
  const [galleryToShow, setGalleryToShow] = useState(null)

  // Two-step (clear now, apply on the next commit) so switching models remounts ModelGallery
  // rather than reusing it: it fetches /listing_page/items/:id from a mount effect and holds
  // carousel/fullscreen state that must not carry over to the next model. List.jsx precedent.
  const handlePreviewClick = useCallback((galleryProps) => {
    setShowGallery(null)
    setGalleryToShow({ ...galleryProps })
  }, [])

  const handleCloseGallery = useCallback(() => {
    setShowGallery(null)
  }, [])

  useEffect(() => {
    setShowGallery(galleryToShow)
  }, [galleryToShow])

  // A new result set (page, filters, sort) invalidates an open panel: the card it anchors to may
  // no longer be rendered, or may now sit on a different row. List.jsx closes on selectedFilters;
  // on search every one of those inputs surfaces as a changed result set.
  useEffect(() => {
    handleCloseGallery()
  }, [resultIdsSignature, handleCloseGallery])

  return { showGallery, handlePreviewClick, handleCloseGallery }
}

export default useResultsGallery
